/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @param object block The block html element.
 *
 * @return  void
 */

const resizeObserver = new ResizeObserver((entries) => {
  for (const entry of entries) {
    const panelBody: HTMLElement = entry.target as HTMLElement
    const panel: HTMLElement | null = panelBody.closest('.wp-block-site-category-page-documents__accordion-panel');

    if (!panel) {
      return;
    }

    if (panel.style.maxHeight && '0px' !== panel.style.maxHeight) {
      panel.style.maxHeight = panelBody.scrollHeight + "px";
    }
  }
});

export function initializeBlock(block: HTMLElement) {
	var acc: NodeListOf<HTMLButtonElement> = block.querySelectorAll(".wp-block-site-category-page-documents__accordion-button");
	var i;

	for (i = 0; i < acc.length; i++) {
		acc[i].addEventListener("click", function(event) {
			this.classList.toggle("wp-block-site-category-page-documents__accordion-button--active");

      const target: HTMLButtonElement = event.target as HTMLButtonElement

			const panel: HTMLElement | null = block.querySelector(`#${target.dataset.target}`);

      if (!panel) {
        return;
      }

			if (panel.style.maxHeight && '0px' !== panel.style.maxHeight) {
				panel.style.maxHeight = '';
			} else {
				panel.style.maxHeight = panel.scrollHeight + "px";
			}
		});

    const accordionButton = acc[i]

    const panel: HTMLElement | null = block.querySelector(`#${accordionButton.dataset.target}`);
    const panelBody: HTMLElement | null | undefined = panel?.querySelector('.wp-block-site-category-page-documents__accordion-panel-body');

    if (panelBody) {
      resizeObserver.observe(panelBody);
    }
	}
}
